import { Component } from '@angular/core';

import { of } from 'rxjs';

import { DocumentsListComponent, PdfViewerComponent } from '@camelot/files-basic';
import { InputSchemaModal } from '@camelot/form-input';
import { CamDocumentsService, DocumentDto, FileType } from '@camelot/services';

import { TestIdDirective } from '@camelot/testing-harness';

const documentMock: DocumentDto = {
  fileType: FileType.Unknown,
  id: 'doc-1',
  name: 'report.pdf',
  uploadedDate: '2026-01-01T10:00:00Z',
  url: 'https://mock.local/report.pdf',
};

const documentsServiceMock = {
  documents: { get$: () => of([documentMock]) },
  fetchDocuments$: () => of([documentMock]),
  getDocuments$: () => of([documentMock]),
};

@Component({
    imports: [DocumentsListComponent, InputSchemaModal, PdfViewerComponent, TestIdDirective],
    providers: [{ provide: CamDocumentsService, useValue: documentsServiceMock }],
    template: `
    <cam-pdf-viewer camTestId="cam-pdf-viewer" [file]="this.file" />
    <cam-documents-list camTestId="cam-documents-list" [documentsIds]="this.documentsIds" />
    <cam-input-schema-modal-content camTestId="cam-input-schema-modal-content" />
  `
})
export class FilesViewersCase {
  public documentsIds = ['doc-1'];
  public file = documentMock;
}
